import React from "react";
import html2canvas from "html2canvas";
import { Download, Share2 } from "lucide-react";
import ShareDialog from './ShareDialog';

export default function BadgeDownload({ playerName = "Explorer", rank = "Wanderer" }) {
  const badgeMap = {
    "Maze Master": "/badges/maze-master.png",
    "Speed Runner": "/badges/speed-runner.png",
    "Navigator": "/badges/navigator.png",
    "Explorer": "/badges/explorer.png",
    "Wanderer": "/badges/wanderer.png"
  };

  const badgeImage = badgeMap[rank] || badgeMap["Wanderer"];
const handleDownload = async () => {
  const badgeNode = document.getElementById("badge-canvas");

  // ✅ Now fetch it when DOM is ready
  const websiteText = document.querySelector(".no-show-in-ui");

  // Temporarily show it for canvas rendering
  websiteText?.classList.remove("no-show-in-ui");

  await new Promise(resolve => setTimeout(resolve, 100));

  const canvas = await html2canvas(badgeNode, {
    backgroundColor: null,
    scale: 3,
    useCORS: true,
    scrollX: 0,
    scrollY: -window.scrollY,
    ignoreElements: (element) => {
      return element.classList?.contains("no-export");
    }
  });

  // Hide it again after rendering
  websiteText?.classList.add("no-show-in-ui");

  const link = document.createElement("a");
  link.download = `MazeMoh_${rank.replace(/\s+/g, "_")}_Badge.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
};

  

  return (
    <div
      id="badge-canvas"
      className="relative w-[300px] h-[300px] rounded-2xl overflow-hidden shadow-lg"
      style={{ backgroundColor: "transparent" }}
    >
      <img
        src={badgeImage}
        alt="Badge"
        className="w-full h-full object-cover"
      />

      {/* Player name overlay */}
      <div className="absolute bottom-14 w-full text-center text-white font-bold text-base text-shadow-sm">
        {playerName}
      </div>

      {/* 🌐 Website URL — only for export */}
 <div className="absolute bottom-3 w-full text-center text-[11px] text-gray-500 no-show-in-ui">
    https://maze.arake.app
  </div>

      {/* Always-visible Icon Buttons */}
      <button
  onClick={handleDownload}
  title="Download Badge"
  className="absolute bottom-3 left-3 w-12 h-12 border border-white rounded-lg flex items-center justify-center bg-white/10 hover:bg-black/20 text-black text-lg no-export"
>
  <Download size={18} />
</button>

<div className="absolute bottom-3 right-3 z-10 no-export">
  <ShareDialog shareLabel={rank} shareUrl="https://https://maze.arake.app" />
</div>

    </div>
  );
}